import { Injectable, inject } from '@angular/core';
import { CanActivate, CanActivateChild, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { MsalAuthService } from '../services/msal-auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild {
  private auth = inject(AuthService);
  private router = inject(Router);
  private msalAuth = inject(MsalAuthService);

  private async check(): Promise<boolean | UrlTree>  {
    await this.msalAuth.waitForMsalReady();
    return this.auth.isAuthenticated() ? true : this.router.parseUrl('/auth/login');
  }

  async canActivate(): Promise<boolean | UrlTree> {
    return this.check();
  }

  async canActivateChild(): Promise<boolean | UrlTree> {
    return this.check();
  }
}